import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import $ from '@sparta.global.vendors/jquery';
import _ from '@sparta.global.vendors/lodash';
import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es5.js';
import workflowUtility from '@sparta.digital-mortgage-application.utilities/workflow-utility/dist/es5.js';
import formsUtility from '@sparta.digital-mortgage-application.utilities/dma-forms-utility/dist/es5.js';
import dmaCartUtility from '@sparta.digital-mortgage-application.utilities/cart-utility/dist/es5.js';
import mloInformationUtility from '@sparta.digital-mortgage-application.utilities/mlo-information-utility/dist/es5.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { json } from '@sparta.global.helpers/json-helper/dist/es5.js';
var Template$1 = Handlebars.template({
  "compiler": [8, ">= 4.3.0"],
  "main": function main(container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "\r\n\r\n<section data-module=\"off-ramp-module\">\r\n  <script type=\"text/json\" class=\"static-content\">" + ((stack1 = (lookupProperty(helpers, "json") || depth0 && lookupProperty(depth0, "json") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, depth0, {
      "name": "json",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 9,
          "column": 50
        },
        "end": {
          "line": 9,
          "column": 65
        }
      }
    })) != null ? stack1 : "") + "</script>\r\n</section>\r\n";
  },
  "useData": true
});
var renderTemplate$1 = function renderTemplate$1(data, options) {
  return Template$1(data, options);
};
var Template = Handlebars.template({
  "1": function _(container, depth0, helpers, partials, data) {
    return "        <p class=\"text-center\">" + container.escapeExpression(container.lambda(depth0, depth0)) + "</p>\r\n";
  },
  "3": function _(container, depth0, helpers, partials, data) {
    var stack1,
      helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "        <div id=\"offRamp" + container.escapeExpression((helper = (helper = lookupProperty(helpers, "key") || data && lookupProperty(data, "key")) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "key",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 13,
          "column": 24
        },
        "end": {
          "line": 13,
          "column": 32
        }
      }
    }) : helper)) + "\" class=\"hide\">\r\n          " + ((stack1 = (lookupProperty(helpers, "renderHeader") || depth0 && lookupProperty(depth0, "renderHeader") || container.hooks.helperMissing).call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "header") : depth0, {
      "name": "renderHeader",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 14,
          "column": 10
        },
        "end": {
          "line": 14,
          "column": 35
        }
      }
    })) != null ? stack1 : "") + "\r\n\r\n          <p class=\"text-center\">" + ((stack1 = container.lambda(depth0 != null ? lookupProperty(depth0, "text1") : depth0, depth0)) != null ? stack1 : "") + "</p>\r\n\r\n" + ((stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, (stack1 = (stack1 = data && lookupProperty(data, "root")) && lookupProperty(stack1, "mloInformation")) && lookupProperty(stack1, "nmlsid"), {
      "name": "if",
      "hash": {},
      "fn": container.program(4, data, 0),
      "inverse": container.program(6, data, 0),
      "data": data,
      "loc": {
        "start": {
          "line": 18,
          "column": 10
        },
        "end": {
          "line": 24,
          "column": 17
        }
      }
    })) != null ? stack1 : "") + "\r\n" + ((stack1 = lookupProperty(helpers, "unless").call(depth0 != null ? depth0 : container.nullContext || {}, depth0 != null ? lookupProperty(depth0, "hideMloBodyCopy") : depth0, {
      "name": "unless",
      "hash": {},
      "fn": container.program(8, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 26,
          "column": 10
        },
        "end": {
          "line": 36,
          "column": 21
        }
      }
    })) != null ? stack1 : "") + "\r\n        </div>\r\n";
  },
  "4": function _(container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "            <h3 class=\"off-ramp-mlo-header headline-small cnx-medium text-center\">\r\n              " + ((stack1 = container.lambda((stack1 = (stack1 = data && lookupProperty(data, "root")) && lookupProperty(stack1, "copy")) && lookupProperty(stack1, "text3"), depth0)) != null ? stack1 : "") + "\r\n            </h3>\r\n";
  },
  "6": function _(container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "            <p class=\"text-center\">" + ((stack1 = container.lambda(depth0 != null ? lookupProperty(depth0, "text2") : depth0, depth0)) != null ? stack1 : "") + "</p>\r\n";
  },
  "8": function _(container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, (stack1 = (stack1 = data && lookupProperty(data, "root")) && lookupProperty(stack1, "mloInformation")) && lookupProperty(stack1, "nmlsid"), {
      "name": "if",
      "hash": {},
      "fn": container.program(9, data, 0),
      "inverse": container.program(14, data, 0),
      "data": data,
      "loc": {
        "start": {
          "line": 27,
          "column": 12
        },
        "end": {
          "line": 35,
          "column": 19
        }
      }
    })) != null ? stack1 : "";
  },
  "9": function _(container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return (stack1 = lookupProperty(helpers, "if").call(depth0 != null ? depth0 : container.nullContext || {}, (stack1 = data && lookupProperty(data, "root")) && lookupProperty(stack1, "showAlternateText"), {
      "name": "if",
      "hash": {},
      "fn": container.program(10, data, 0),
      "inverse": container.program(12, data, 0),
      "data": data,
      "loc": {
        "start": {
          "line": 28,
          "column": 14
        },
        "end": {
          "line": 32,
          "column": 21
        }
      }
    })) != null ? stack1 : "";
  },
  "10": function _(container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "                <p class=\"text-center\">" + ((stack1 = container.lambda((stack1 = (stack1 = data && lookupProperty(data, "root")) && lookupProperty(stack1, "copy")) && lookupProperty(stack1, "text6"), depth0)) != null ? stack1 : "") + "</p>\r\n";
  },
  "12": function _(container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "                <p class=\"text-center\">" + ((stack1 = container.lambda((stack1 = (stack1 = data && lookupProperty(data, "root")) && lookupProperty(stack1, "copy")) && lookupProperty(stack1, "text4"), depth0)) != null ? stack1 : "") + "</p>\r\n";
  },
  "14": function _(container, depth0, helpers, partials, data) {
    var stack1,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "              <p class=\"text-center\">" + ((stack1 = container.lambda((stack1 = (stack1 = data && lookupProperty(data, "root")) && lookupProperty(stack1, "copy")) && lookupProperty(stack1, "text5"), depth0)) != null ? stack1 : "") + "</p>\r\n";
  },
  "compiler": [8, ">= 4.3.0"],
  "main": function main(container, depth0, helpers, partials, data) {
    var stack1,
      helper,
      lookupProperty = container.lookupProperty || function (parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined;
      };
    return "\r\n<div class=\"off-ramp-route-wrapper\">\r\n\r\n  <div class=\"row\">\r\n    <div class=\"column " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "columnDefaultLayout") || (depth0 != null ? lookupProperty(depth0, "columnDefaultLayout") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "columnDefaultLayout",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 6,
          "column": 23
        },
        "end": {
          "line": 6,
          "column": 46
        }
      }
    }) : helper)) + "\">\r\n\r\n" + ((stack1 = lookupProperty(helpers, "with").call(depth0 != null ? depth0 : container.nullContext || {}, (stack1 = depth0 != null ? lookupProperty(depth0, "copy") : depth0) != null ? lookupProperty(stack1, "content") : stack1, {
      "name": "with",
      "hash": {},
      "fn": container.program(1, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 8,
          "column": 6
        },
        "end": {
          "line": 10,
          "column": 15
        }
      }
    })) != null ? stack1 : "") + "\r\n" + ((stack1 = lookupProperty(helpers, "each").call(depth0 != null ? depth0 : container.nullContext || {}, (stack1 = depth0 != null ? lookupProperty(depth0, "copy") : depth0) != null ? lookupProperty(stack1, "codeContent") : stack1, {
      "name": "each",
      "hash": {},
      "fn": container.program(3, data, 0),
      "inverse": container.noop,
      "data": data,
      "loc": {
        "start": {
          "line": 12,
          "column": 6
        },
        "end": {
          "line": 39,
          "column": 15
        }
      }
    })) != null ? stack1 : "") + "\r\n    </div>\r\n    <div class=\"column " + container.escapeExpression((helper = (helper = lookupProperty(helpers, "mloDefaultLayout") || (depth0 != null ? lookupProperty(depth0, "mloDefaultLayout") : depth0)) != null ? helper : container.hooks.helperMissing, typeof helper === "function" ? helper.call(depth0 != null ? depth0 : container.nullContext || {}, {
      "name": "mloDefaultLayout",
      "hash": {},
      "data": data,
      "loc": {
        "start": {
          "line": 42,
          "column": 23
        },
        "end": {
          "line": 42,
          "column": 43
        }
      }
    }) : helper)) + "\">\r\n\r\n      <div class=\"insert-mlo-info\"></div>\r\n\r\n    </div>\r\n  </div>\r\n</div>";
  },
  "useData": true
});
var renderTemplate = function renderTemplate(data, options) {
  options = options || {};
  options.helpers = options.helpers || {};
  options.partials = options.partials || {};
  options.helpers = _objectSpread(_objectSpread({}, options.helpers), _moduleConfig.helpers);
  options.partials = _objectSpread(_objectSpread({}, options.partials), _moduleConfig.partials);
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.digital-mortgage-application.modules/off-ramp-module",
  "version": "2.0.1",
  "id": "offRampModule",
  "containerID": "digitalMortgageApplicationOffRampModule",
  "moduleName": "digital-mortgage-application-off-ramp-module",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "off-ramp-module",
  "data": {
    "init": "offRampModuleJS",
    "options": {
      "copy": "{{json copy}}"
    }
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function render(context) {
    return renderTemplate$1(context, {
      "helpers": {
        json: json
      },
      "partials": {
        "default": renderTemplate
      }
    });
  },
  "template": renderTemplate$1,
  "partials": {
    "default": renderTemplate
  },
  "helpers": {
    json: json
  },
  "dependencies": {
    "@sparta.digital-mortgage-application.utilities/cart-utility": "^2.0.0",
    "@sparta.digital-mortgage-application.utilities/dma-forms-utility": "^2.0.0",
    "@sparta.digital-mortgage-application.utilities/mlo-information-utility": "^2.0.0",
    "@sparta.digital-mortgage-application.utilities/workflow-utility": "^2.0.0",
    "@sparta.global.vendors/lodash": "^4.17.21",
    "@sparta.global.helpers/json-helper": "^1.0.0",
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-store-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.global.vendors/jquery": "^3.2.1"
  },
  "stores": []
};

/*
 * off-ramp-module
 * module_js_id: offRampModuleJS
 *
 * Copyright (c) 2017-5-18 nbdzrui
 */

var serviceFailureCode = 'OR014';

/**
 * Off Ramp Module Sparta class
 */
var OffRampModuleJS = /*#__PURE__*/function (_Module) {
  /**
   * Sparta module instance constructor
   * @param {Object} options Sparta options
   * @param {Object} context Sparta context
   */
  function OffRampModuleJS(options, context) {
    var _this;
    _classCallCheck(this, OffRampModuleJS);
    _this = _callSuper(this, OffRampModuleJS, [_objectSpread(_objectSpread({}, options), {}, {
      context: context,
      config: _moduleConfig
    })]);
    _this.$target = $('.off-ramp-module');
    return _this;
  }

  /**
   * Workflow lifecycle method - calls after router partials have been run and added to the DOM.
   * @param {$} $module JQuery reference to the module element.
   * @param {Function} dispatch Dispatches an action to the store.
   * @param {Function} getState Gets the state from the store.
   * @returns {void}
   */
  _inherits(OffRampModuleJS, _Module);
  return _createClass(OffRampModuleJS, [{
    key: "onMount",
    value: function onMount($module, dispatch, getState) {
      var state = getState();
      var dataReceived = state.dataReceived,
        dataSources = state.dataSources;
      var isAuthenticated = dataReceived.isAuthenticated,
        savedApplicationId = dataReceived.savedApplicationId,
        applicationId = dataReceived.applicationId,
        mloInformation = dataReceived.mloInformation;
      var _ref = mloInformation || {},
        nmlsid = _ref.nmlsid,
        firstName = _ref.firstName,
        lastName = _ref.lastName;
      if (nmlsid && firstName && lastName) {
        var mloInfoContainer = document.querySelector('.insert-mlo-info');
        mloInfoContainer.innerHTML = mloInformationUtility.initMlo(dataReceived, dataSources.copy);
      }
      var offRampCode = dataReceived.offRampCode || serviceFailureCode;
      if (offRampCode) {
        document.getElementById("offRamp".concat(offRampCode)).classList.remove('hide');
      }
      if (offRampCode === 'OR024') {
        $module.find('.off-ramp-mlo-header').addClass('hide');
      }
      var phoneNumber = dataReceived.subCampPhoneNumber || state.subCampPhoneNumber;
      phoneNumber = _.isEmpty(phoneNumber) ? dataSources.copy.defaultSubCampPhoneNumber : phoneNumber;
      $module.find('.off-ramp-phone-number').each(function (idx, el) {
        var $el = $(el);
        $el.text(phoneNumber);
      });
      if (state && state.mloInformation && state.mloInformation.firstName) {
        var loName = "".concat(state.mloInformation.firstName, " ").concat(state.mloInformation.lastName);
        $module.find('.lo-name').each(function (idx, el) {
          var $el = $(el);
          $el.text(loName);
        });
      }
      if (isAuthenticated) {
        if (savedApplicationId && applicationId) {
          // remove saved application from cart
          var removeSavedAppProm = dmaCartUtility.removeSavedApplicationFromCart(applicationId, savedApplicationId);
          removeSavedAppProm.then(function () {
            dmaCartUtility.signOff();
          }).catch(function () {
            dmaCartUtility.signOff();
          });
        } else {
          dmaCartUtility.signOff();
        }
      }
    }

    /**
     * Workflow lifecycle method - calls before partial is run for the route.
     * @param {Object} copy Contains JCR/copy for routes.
     * @param {Object} state Redux state.
     * @param {Object} response Backend response for the route init-data.
     * @param {String} dataSource The data source for the current route (to index copy with).
     * @returns {Object} Data sent to the handlebars partial.
     */
  }, {
    key: "render",
    value: function render(copy, state, response, dataSource) {
      var offRampCode = response.offRampCode;
      var hideMloBodyCopy = offRampCode === 'OR010' || offRampCode === 'OR016';
      var phoneNumber = state.mloInformation ? state.mloInformation.phoneNumber : null;
      phoneNumber = phoneNumber ? "".concat(phoneNumber.slice(0, 3), ".").concat(phoneNumber.slice(3, 6), ".").concat(phoneNumber.slice(6)) : phoneNumber;
      var showAlternateText = offRampCode === 'OR005' || offRampCode === 'OR008';
      var updatedJCR = _objectSpread(_objectSpread(_objectSpread({}, copy[dataSource]), response), {}, {
        mloPhoneNumber: phoneNumber,
        hideMloBodyCopy: hideMloBodyCopy,
        showAlternateText: showAlternateText,
        offRampCode: offRampCode
      });
      var returnValue = formsUtility.postRenderLogic(updatedJCR, copy, state, response, dataSource, workflowUtility.getCurrentRoute().routeName);
      returnValue.copy = this.settings.copy;
      return returnValue;
    }

    /**
     * Initializes the module, called on page load.
     * @returns {void}
     */
  }, {
    key: "init",
    value: function init() {
      var initModuleResult = workflowUtility.actions.initModule(this.$target, {
        onMount: this.onMount.bind(this),
        render: this.render.bind(this)
      }, {}, ['off-ramp'], null, this);
      workflowUtility.dispatch(initModuleResult);
    }
  }]);
}(Module);
/* istanbul ignore next */
registerModuleClass({
  moduleClass: OffRampModuleJS,
  moduleConfig: _moduleConfig
});
var moduleConfig = _moduleConfig;
export { OffRampModuleJS as default, moduleConfig };